export default "__VITE_ASSET__DjtNWfip__"